import { inject, Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import Swal, { SweetAlertOptions } from "sweetalert2";

@Injectable({
  providedIn: "root",
})
export class SweetAlertService {
  constructor() {}
  swalComponent!: SwalComponent;

  swalOptions: SweetAlertOptions = {};

  #translate = inject(TranslateService);

  swalSuccess(title?: string, text?: string) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        icon: "success",
        title: title || this.#translate.instant("SWEETALERT.SUCCESS_TITLE"),
        text: text || this.#translate.instant("SWEETALERT.SUCCESS_TEXT"),
        showConfirmButton: false,
        heightAuto: false,
        // showClass: {
        //   popup: 'animate__animated animate__fadeInUp',
        // },
        // hideClass: {
        //   popup: 'animate__animated animate__fadeOutDown',
        // },
        timer: 2000,
      }).then((_) => {
        resolve(true);
      });
    });
  }

  swalAlert(title?: string, text?: string, showConfirmButton: boolean = false) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        icon: "error",
        // style : "danger",
        title: title || this.#translate.instant("SWEETALERT.ERROR_TITLE"),
        text: text || this.#translate.instant("SWEETALERT.ERROR_TEXT"),
        showConfirmButton: showConfirmButton,
        heightAuto: false,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-danger danger",
        },
        // showClass: {
        //   popup: "animate__animated animate__fadeInUp",
        // },
        // hideClass: {
        //   popup: "animate__animated animate__fadeOutDown",
        // },
        timer: 2000,
      }).then((_) => {
        resolve(true);
      });
    });
  }

  swalWarning(title?: string, text?: string) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        icon: "warning",
        title: title || this.#translate.instant("SWEETALERT.WARNING_TITLE"),
        text: text || this.#translate.instant("SWEETALERT.WARNING_TEXT"),
        showConfirmButton: true,
        heightAuto: false,
        // showClass: {
        //   popup: "animate__animated animate__fadeInUp",
        // },
        // hideClass: {
        //   popup: "animate__animated animate__fadeOutDown",
        // },
        customClass: {
          // White on #2093c9 measures 3.2:1 — under the 4.5:1 a button label needs,
          // and this is the confirm button on every dialog in the app. The brand
          // fill carries the palette's own ink at 8:1.
          confirmButton: "btn btn-primary",
        },
        confirmButtonText: this.#translate.instant("COMPONENT.CLOSE"),
        didOpen: () => Swal!.getConfirmButton()!.blur(),
      }).then((_) => {
        resolve(true);
      });
    });
  }

  swalConfirmation(
    title?: string,
    text?: string,
    confirmButtonText?: string,
    cancelButtonText?: string
  ) {
    const promise = new Promise((resolve, reject) => {
      Swal.fire({
        title:
          title || this.#translate.instant("SWEETALERT.CONFIRMATION_TITLE"),
        text: text || this.#translate.instant("SWEETALERT.CONFIRMATION_TEXT"),
        icon: "warning",
        showCancelButton: true,
        heightAuto: false,
        reverseButtons: true,

        // showClass: {
        //   popup: "animate__animated animate__fadeInUp",
        // },
        // hideClass: {
        //   popup: "animate__animated animate__fadeOutDown",
        // },
        // showLoaderOnConfirm: true,
        // customClass: {
        //   confirmButton: "btn btn-primary",
        //   cancelButton: "btn",
        // },

        customClass: {
          cancelButton: "btn btn-secondary",
          confirmButton: "btn btn-primary",
          popup: `min-w-425px`,
          title: "fw-bold mt-4",
          htmlContainer: "mt-1 pt-2 ",
          actions: "mt-3 gap-3 mb-0",
        },
        confirmButtonText:
          confirmButtonText || this.#translate.instant("COMPONENT.CONFIRM"),
        cancelButtonText:
          cancelButtonText || this.#translate.instant("COMPONENT.CANCEL"),
        didOpen: () => Swal.getConfirmButton()!.blur(),
      }).then((result) => {
        if (result.value) {
          resolve(true);
        }
      });
    });
    return promise;
  }

  swalLoading(title?: string, text?: string) {
    return new Promise((resolve, reject) => {
      Swal.fire({
        // icon: 'error',
        title: title || this.#translate.instant("SWEETALERT.PROCESSING_TITLE"),
        text: text || this.#translate.instant("SWEETALERT.PROCESSING_TEXT"),
        showConfirmButton: false,
        heightAuto: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        // showClass: {
        //   popup: 'animate__animated animate__fadeInUp',
        // },
        // hideClass: {
        //   popup: 'animate__animated animate__fadeOutDown',
        // },
        didOpen: () => {
          Swal.showLoading();
        },
        // timer: 2000,
      }).then(
        (_) => {
          resolve(true);
        },
        () => {}
      );
    });
  }
  swalClose() {
    return new Promise((resolve, reject) => {
      Swal.close();
    });
  }
}
